export async function loadNamespace(lng, ns) {
    if (lng === "en" && ns === "auth") return (await import("../locales/en/auth.json")).default;
    if (lng === "uk" && ns === "auth") return (await import("../locales/uk/auth.json")).default;

    if (lng === "en" && ns === "validation") return (await import("../locales/en/validation.json")).default;
    if (lng === "uk" && ns === "validation") return (await import("../locales/uk/validation.json")).default;

    if (lng === "en" && ns === "menu") return (await import("../locales/en/menu.json")).default;
    if (lng === "uk" && ns === "menu") return (await import("../locales/uk/menu.json")).default;

    if (lng === "en" && ns === "common") return (await import("../locales/en/common.json")).default;
    if (lng === "uk" && ns === "common") return (await import("../locales/uk/common.json")).default;
  
    return {};
  }
  